import { Controller } from "@hotwired/stimulus"

// Handles day selection and navigation in the calendar
export default class extends Controller {
  static targets = ["day", "grid"]
  static values = { currentDate: String, selectedDate: String }

  connect() {
    // Listen for Turbo frame load to clear loading states
    this.boundClearLoading = this.clearLoadingStates.bind(this)
    document.addEventListener("turbo:frame-load", this.boundClearLoading)
  }

  disconnect() {
    document.removeEventListener("turbo:frame-load", this.boundClearLoading)
  }

  selectDay(event) {
    const date = event.currentTarget.dataset.date
    this.selectedDateValue = date
    this.dispatch("daySelected", { detail: { date } })

    // Add loading state to clicked day
    event.currentTarget.classList.add("day-loading")
  }

  selectedDateValueChanged() {
    // Clear selection from all days
    this.dayTargets.forEach(day => {
      day.classList.remove("ring-2", "ring-accent-500")
    })

    // Add selection to the selected day
    if (this.selectedDateValue) {
      const selectedDay = this.dayTargets.find(
        day => day.dataset.date === this.selectedDateValue
      )
      if (selectedDay) {
        selectedDay.classList.add("ring-2", "ring-accent-500")
      }
    }
  }

  /**
   * Clear loading states from all day cells after content loads
   */
  clearLoadingStates(event) {
    // Only respond to events_list frame loads
    if (event.target.id === "events_list") {
      this.dayTargets.forEach(day => {
        day.classList.remove("day-loading")
      })
    }
  }
}
